export default "__VITE_ASSET__6f9621c2__"